import React from "react";
import { Tabs } from "antd";
import styled from "@emotion/styled";

const ScrollableTabs = styled.div`
  overflow-x: auto;
  margin-bottom: 16px;
  -webkit-overflow-scrolling: touch;

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-nav-wrap {
    flex: 1 1 auto;
  }
`;

export type AgentListTabItem = {
  key: string;
  label: string;
  count?: number;
};

interface AgentListTabsProps {
  activeKey: string;
  onChange: (key: string) => void;
  items: AgentListTabItem[];
}

/** Status / category tabs matching the Bookings list layout. */
export const AgentListTabs: React.FC<AgentListTabsProps> = ({
  activeKey,
  onChange,
  items,
}) => (
  <ScrollableTabs>
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      items={items.map((tab) => ({
        key: tab.key,
        label:
          tab.count != null ? `${tab.label} (${tab.count})` : tab.label,
      }))}
    />
  </ScrollableTabs>
);
